import React from 'react'

const Tutorial = () =>{
    return (
        <h1 className="text-center">Coming Soon</h1>
    )
}

export default Tutorial